import { render, staticRenderFns } from "./TheWrapper.vue?vue&type=template&id=9020f39e&"
import script from "./TheWrapper.vue?vue&type=script&lang=js&"
export * from "./TheWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TheWrapper.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports